import React, { useEffect } from 'react';

// 1. Import Swiper และ Modules ที่จำเป็น
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';

// 2. Import หน้าต่างๆ ของคุณ
import Notification from './Notification';
import QRCode from './QrCode';

// 3. Import utils และ CSS
import { getSubUser } from '../utils/auth';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const MainPage = () => {
  // เช็คการ login เมื่อคอมโพเนนต์ถูกโหลด
  useEffect(() => {
    const subUser = getSubUser();
    if (!subUser) {
      window.location.href = '/login';
    }
  }, []);

  return (
    // ไม่จำเป็นต้องมี div ครอบอีกชั้น สามารถใช้ Swiper เป็น container หลักได้เลย
    <Swiper
      // Modules ที่จะใช้ (เช่น ปุ่ม next/prev, จุด pagination)
      modules={[Navigation, Pagination]}
      
      // ตั้งค่าพื้นฐาน
      spaceBetween={0} // ไม่มีช่องว่างระหว่างสไลด์
      slidesPerView={1} // แสดงทีละ 1 สไลด์
      
      // กำหนดสไลด์เริ่มต้น (index 1 คือหน้า Notification)
      initialSlide={0} 

      // เปิด/ปิด UI ของ Swiper (เลือกใช้ตามความต้องการ)
      // navigation // แสดงปุ่ม Next/Prev
      // pagination={{ clickable: true }} // แสดงจุดๆ และให้คลิกได้
    >

      {/* สไลด์ที่ 0 (หน้าหลัก) */}
      <SwiperSlide>
        <Notification />
      </SwiperSlide>

      {/* สไลด์ที่ 1 */}
      <SwiperSlide>
        <QRCode />
      </SwiperSlide>
    </Swiper>
  );
};

export default MainPage;